<template>
    <img src="@/assets/images/hand-wave-icon.gif" alt="" />
</template>